import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_DEVICES_REQUEST,
  fetchDevicesSuccess,
  fetchDevicesFailure,
  UPDATE_DEVICE_REQUEST,
  updateDeviceSuccess,
  updateDeviceFailure,
  UPDATE_PAYMENT_REQUEST,
  updatePaymentSuccess,
  updatePaymentFailure,
  SEARCH_DEVICES_REQUEST,
  searchDevicesSuccess,
  searchDevicesFailure,
  SEARCH_PAYMENTS_REQUEST,
  searchPaymentsSuccess,
  searchPaymentsFailure
} from "./devicesActions";
import SDK from "../../config";


function* fetchDevices(action) {
  const { page, limit } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/id/info?page=${page}&limit=${limit}`);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = yield response.json();
    yield put(fetchDevicesSuccess(data.data));
  } catch (error) {
    yield put(fetchDevicesFailure(error.toString()));
  }
}

function* searchDevices(action) {
  const { searchTerm } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/id/info/search?searchTerm=${searchTerm}`);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = yield response.json();
    yield put(searchDevicesSuccess(data.data));
  } catch (error) {
    yield put(searchDevicesFailure(error.toString()));
  }
}

function* searchPayments(action) {
  const { searchTerm } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/id/info/payment?searchTerm=${searchTerm}`);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = yield response.json();
    yield put(searchPaymentsSuccess(data.data));
  } catch (error) {
    yield put(searchPaymentsFailure(error.toString()));
  }
}

function* updateDevice(action) {
  try {
    const { device_ID, device_name, device_OS } = action.payload;
    const response = yield call(fetch, `${SDK.SOCKET_URL}/id/info/${device_ID}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ device_name, device_OS }),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = yield response.json();
    yield put(updateDeviceSuccess(data));
  } catch (error) {
    yield put(updateDeviceFailure(error.toString()));
  }
}

function* updatePayment(action) {
  try {
    const { device_ID, payment_type, payment_expiry_date } = action.payload;
    const response = yield call(fetch, `${SDK.SOCKET_URL}/id/payment/${device_ID}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        payment_check: true,
        payment_type,
        payment_expiry_date,
      }),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = yield response.json();
    yield put(updatePaymentSuccess(data));
  } catch (error) {
    yield put(updatePaymentFailure(error.toString()));
  }
}

function* devicesSaga() {
  yield takeLatest(FETCH_DEVICES_REQUEST, fetchDevices);
  yield takeLatest(UPDATE_DEVICE_REQUEST, updateDevice);
  yield takeLatest(UPDATE_PAYMENT_REQUEST, updatePayment);
  yield takeLatest(SEARCH_DEVICES_REQUEST, searchDevices);
  yield takeLatest(SEARCH_PAYMENTS_REQUEST, searchPayments)
}

export default devicesSaga;
